import { Route } from 'found';

export default class VersionedRoute extends Route {
  getComponent = async ({ routeParams }) => {
    if (routeParams.eventSlug === 'soccer') {
      return this.Component.soccer;
    }
    // if (routeParams.eventSlug === 'perduekrogerrefund') {
    //   return this.Component.perdue;
    // }
    return this.Component.new;
  };
}
